import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { fetchSessionDetails } from "../services/paymentService";
import { FaTimesCircle } from "react-icons/fa";

const CancelPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [sessionDetails, setSessionDetails] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const getSessionDetails = async () => {
      try {
        setLoading(true);
        const data = await fetchSessionDetails(sessionId);
        setSessionDetails(data);
        setError(null);
      } catch (error) {
        console.error(error.message);
        setError("Invalid URL. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    if (sessionId) {
      getSessionDetails();
    } else {
      setError("Invalid URL. Please try again.");
      setLoading(false);
    }
  }, [sessionId]);

  const handleViewReport = () => {
    if (sessionDetails?.metadata?.emissionId) {
      navigate(`/calculator?emissionId=${sessionDetails.metadata.emissionId}`);
    }
  };

  const handleGoToCalculation = () => {
    navigate("/calculator");
  };

  return (
    <div
      className="container mt-5"
      style={{ fontFamily: "Oswald, sans-serif" }}
    >
      <div className="text-center mb-4">
        <h1 style={{ color: "#063970" }}>YPO Carbon Offset Cancellation</h1>
        <p className="text-muted">
          Your transaction was canceled. You can retry anytime.
        </p>
      </div>

      <div className="d-flex justify-content-center">
        {loading ? (
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p>Loading...</p>
          </div>
        ) : error ? (
          <div
            className="card text-center border-danger"
            style={{ maxWidth: "500px", width: "100%" }}
          >
            <div className="card-body">
              <FaTimesCircle size={40} color="#dc3545" className="mb-3" />
              <h5 className="card-title text-danger">Error</h5>
              <p className="card-text">{error}</p>
              <button
                className="btn btn-secondary mt-3"
                onClick={handleGoToCalculation}
              >
                Go to Calculation Page
              </button>
            </div>
          </div>
        ) : (
          <div
            className="card text-center shadow"
            style={{ maxWidth: "500px", width: "100%", borderColor: "#063970" }}
          >
            <div className="card-body">
              <FaTimesCircle size={40} color="#063970" className="mb-3" />
              <h2 className="card-title" style={{ color: "#063970" }}>
                Payment Canceled
              </h2>
              <p className="card-text">
                Your payment was canceled. You can try again if you'd like.
              </p>
              {sessionDetails && (
                <div className="mb-3">
                  <p className="mb-1">
                    Amount: ${(sessionDetails.amount_total / 100).toFixed(2)}
                  </p>
                  <p>Status: {sessionDetails.payment_status}</p>
                </div>
              )}
              <button
                className="btn btn-secondary mt-2"
                onClick={handleViewReport}
              >
                Go to Calculation Page & Try Again
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CancelPage;
